import { render, staticRenderFns } from "./postAndDpd.vue?vue&type=template&id=43e08e4c&scoped=true"
import script from "./postAndDpd.vue?vue&type=script&lang=js"
export * from "./postAndDpd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e08e4c",
  null
  
)

export default component.exports